import { Product } from '@/types/product';
import { create } from 'zustand';

interface ProductStore {
  products: Product[];
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const useProductStore = create<ProductStore>((set) => ({
  products: [],
  searchQuery: '',
  setSearchQuery: (query) => set({ searchQuery: query }),
})); 